// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__-WsUu","tooltip":"styles_tooltip__VanKJ","tooltipWrapper":"styles_tooltipWrapper__2teUk","actionTriggerScreen":"styles_actionTriggerScreen__v-Qg+"};